<template>
  <b-modal id="profiling-modal" centered hide-footer size="md">
    <div class="mb-4">
      <div
        class="typeform-widget"
        data-tf-widget="https://form.typeform.com/to/UQMv202K"
        data-tf-opacity="100"
        data-tf-iframe-props="title=sign_up"
        data-tf-transitive-search-params
        data-tf-medium="snippet"
        :data-tf-hidden="`user_id=${$auth.user.id},email=${$auth.user.email}`"
      ></div>
      <script src="//embed.typeform.com/next/embed.js"></script>
    </div>
  </b-modal>
</template>

<script>
export default {
  mounted() {
    window.addEventListener('message', (event) => {
      if (event.origin !== 'https://form.typeform.com') return;
      if (event.data.type === 'form-submit') {
        this.$bvModal.hide('profiling-modal');
      }
    });
  }
};
</script>
<style lang="scss">
#profiling-modal {
  align-items: center;
  height: 100%;
  .modal-body {
    padding: 0;
  }
  .modal-content {
    border: none;
  }
  .modal-header {
    border: none;
    padding: 0;
  }
  .modal-footer {
    display: none;
  }
  .modal-dialog {
    width: 400px;
  }
  .close {
    outline: none;
    position: absolute;
    right: -20px;
    top: 15px;
    background-color: #ffffff40;
    width: 30px;
    border-radius: 50%;
    justify-content: center;
    height: 30px;
    display: flex;
    text-align: center;
    align-items: center;
    color: white;
    opacity: 1;
    font-weight: 400;
    z-index: 100;
    @include md {
      right: 20px;
      top: 20px;
      color: #505050;
      background-color: transparent;
    }
  }
}
.typeform-widget {
  height: 600px;
  width: 100%;
}
</style>
